/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgDynamicTag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.68755 2.96017C5.10876 2.96863 5.48325 3.23037 5.63594 3.62302L7.64551 8.79052L8.94185 11.5589C9.18542 12.0791 8.9612 12.6982 8.44102 12.9418C7.92085 13.1854 7.30171 12.9612 7.05814 12.441L6.02749 10.24H3.1167L2.3052 12.3702C2.10072 12.9069 1.49984 13.1763 0.963096 12.9718C0.426347 12.7674 0.156984 12.1665 0.361457 11.6297L1.42811 8.82973C1.43392 8.81448 1.44009 8.79936 1.44661 8.78439L3.7133 3.58439C3.88164 3.19819 4.26634 2.95171 4.68755 2.96017ZM3.98782 8.15996H5.16855L4.61184 6.7284L3.98782 8.15996ZM12 7.70663C11.1016 7.70663 10.3733 8.43491 10.3733 9.3333C10.3733 10.2317 11.1016 10.96 12 10.96C12.8984 10.96 13.6267 10.2317 13.6267 9.3333C13.6267 8.43491 12.8984 7.70663 12 7.70663ZM13.7997 6.09206C13.2668 5.79554 12.6531 5.62663 12 5.62663C9.95286 5.62663 8.29333 7.28616 8.29333 9.3333C8.29333 11.3804 9.95286 13.04 12 13.04C12.6531 13.04 13.2668 12.8711 13.7997 12.5745C13.9859 12.855 14.3047 13.04 14.6667 13.04C15.241 13.04 15.7067 12.5743 15.7067 12V6.66663C15.7067 6.09225 15.241 5.62663 14.6667 5.62663C14.3047 5.62663 13.9859 5.81154 13.7997 6.09206Z'
      fill='#29343D'
    />
  </svg>
)
export default SvgDynamicTag
